import type { ReactNode } from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import { CrossLg } from '../../icons/mono/CrossLg';

type ExtendedConfirmDialogProps = Dialog.DialogProps & {
  title?: ReactNode;
  description?: ReactNode;
  confirmLabel?: ReactNode;
  customButtons?: ReactNode;
  onClick?: () => void;
  confirmDisabled?: boolean;
};

export const ExtendedConfirmModal = ({
  children,
  title,
  description,
  onClick,
  confirmLabel = 'Confirm',
  customButtons,
  confirmDisabled,
  ...props
}: ExtendedConfirmDialogProps) => {
  return (
    <Dialog.Root {...props}>
      <Dialog.Portal>
        <Dialog.Overlay className="msq-dialog msq-dialog-default msq-dialog-animate">
          <Dialog.Close className="msq-dialog-close-button">
            <CrossLg className="msq-dialog-close-button-icon" />
          </Dialog.Close>

          <Dialog.Content
            aria-describedby={undefined}
            className="msq-dialog-content msq-dialog-content-md"
          >
            <div className="msq-dialog-header">
              <Dialog.Title className="msq-dialog-title">{title}</Dialog.Title>
            </div>

            <div className="msq-dialog-body py-6">
              {description}
              {children ? children : null}
            </div>
            <div className="msq-dialog-footer msq-dialog-buttons">
              <Dialog.Close className="msq-btn msq-btn-lg msq-btn-secondary">Cancel</Dialog.Close>
              {customButtons && customButtons}

              {!customButtons && (
                <button
                  className="msq-btn msq-btn-lg msq-btn-primary"
                  onClick={onClick}
                  disabled={confirmDisabled}
                >
                  {confirmLabel}
                </button>
              )}
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
